<template>
  <v-app-bar
    app
    flat
    height="60"
    class="naj-header naj-second-header"
    color="#203f39"
  >
    <v-row class="container-fluid">
      <nav class="navbar navbar-light navbar-expand-lg topnav-menu">
        <div
          id="topnav-menu-content"
          class="collapse navbar-collapse"
        >
          <ul class="navbar-nav">
            <li class="nav-item">
              <router-link
                id="topnav-apps"
                role="button"
                class="nav-link"
                :to="'/'"
              >
                <i class="mdi mdi-home me-1" />
                {{ local.secondHeader.mainPage }}
              </router-link>
            </li>

            <li class="nav-item ">
              <router-link
                id="topnav-apps"
                role="button"
                class="nav-link"
                :to="'/profile'"
              >
                <i class="mdi mdi-card-bulleted-settings-outline me-1" />
                {{ local.secondHeader.profilePage }}
              </router-link>
            </li>
            <li class="nav-item ">
              <a
                id="topnav-apps"
                role="button"
                class="nav-link"
                href="https://www.scj.gov.sa/#contact"
                target="_blank"
              >
                <i class="mdi mdi mdi-lifebuoy me-1" />
                {{ local.secondHeader.helpPage }}
              </a>
            </li>
          </ul> <!-- end navbar-->
        </div> <!-- end .collapsed-->
      </nav>
    </v-row>
  </v-app-bar>
</template>
<script>
import { createNamespacedHelpers } from 'vuex';
const { mapState, mapActions } = createNamespacedHelpers('GlobalModule');

export default {
  name: 'NajSecondHeader',
  components: {},
  data() {
    return {};
  },
  computed: { ...mapState(['userInfo']) },
  mounted() {
    this.getUserInfo();
  },
  methods: { ...mapActions(['getUserInfo']) },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/partials/_vars.scss";
.naj-second-header {
  margin-top: 80px !important;
  z-index: 99;
}
.nav-link:hover {
  background-color: transparent;
  color: #fff !important;
}
.nav-link.router-link-exact-active {
  background-color: transparent;
  color: #fff !important;
}
.navbar-nav .nav-link {
  font-size: 1.1rem;
  position: relative;
  line-height: 22px;
  padding: calc(33px / 2) 2.5rem;
  padding-right: 0px;
  color: rgba(255, 255, 255, 0.7);
}
.navbar-nav {
  display: flex;
  list-style: none;
  padding-left: 0;
}
.navbar-nav li {
  margin-right: 0px;
}
@media (min-width: 992px) {
  .navbar-expand-lg {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
}
</style>
